module.exports = __webpack_public_path__ + "img/pic_flower@2x.6a0ada01.png";